import { Injectable, inject } from '@angular/core';
import { catchError, first, map, mergeMap, of } from 'rxjs';
import { EffectsBase } from 'clicklease-ui-elements';
import { LeaseService } from '../../services';
import { getContractSelectedIdSelector } from '../../ngrx';
import { DownloadLeaseAgreementDataError, DownloadLeaseAgreementDataSuccessAction, LoadDownloadLeaseAgreementAction } from '../../ngrx/download-lease-agreement/download-lease-agreement.action';
import { ofType } from '@ngrx/effects';

@Injectable()
export class DownloadLeaseAgreementEffectsService extends EffectsBase {
    
    readonly #leaseService = inject(LeaseService);
    readonly #contractSelected = this.store.selectSignal(getContractSelectedIdSelector);

    getAgreement = this.createEffect(() =>
        this.actions.pipe(
            ofType(LoadDownloadLeaseAgreementAction),
            mergeMap(() => {
                return this.#leaseService.getAgreement(this.#contractSelected()).pipe(
                    map((data) => DownloadLeaseAgreementDataSuccessAction({ data })),
                    catchError((error) => of(DownloadLeaseAgreementDataError({ error: error.message }))),
                    first()
                )
            }))
    );
}